import cn from "classnames";

import type { FeedItem } from "../../../../types/content/feedItem";

import styles from "./LatestNewsArticleCluster.module.scss";
import { Teaser } from "../../../Teaser/Teaser";
import { TeaserCluster } from "../../../TeaserCluster/TeaserCluster";
import { isArticle } from "../../../../utils/typechecks";

const LatestNewsArticleCluster = ({
  feedGroup,
  isLastElement,
  isFirstElement,
  shouldPrioritizeImageLoad,
  positionInFeed,
  teaserWeight,
}: {
  feedGroup: FeedItem;
  isLastElement?: boolean;
  isFirstElement?: boolean;
  shouldPrioritizeImageLoad?: boolean;
  positionInFeed: number;
  teaserWeight: number | null;
}) => {
  return (
    <div
      className={cn([
        styles.latestNewsArticleContainer,
        isFirstElement && styles.firstArticle,
        isLastElement && styles.lastArticle,
      ])}
    >
      <TeaserCluster
        footer={[]}
        header={feedGroup.header}
        style={feedGroup.style}
        hasCardStyling={false}
        isSmallCluster
        teaserWeightValue={teaserWeight}
      >
        {feedGroup.articles
          .filter((g) => isArticle(g))
          .map((group, index) => {
            return (
              <Teaser
                article={group}
                positionInFeed={positionInFeed}
                articlePositionInCluster={index + 1}
                key={`${feedGroup.id} ${index}`}
                hasPriorityImage={shouldPrioritizeImageLoad}
                inCluster
                isBox={feedGroup.style === "premium"}
                isNative={feedGroup.style === "native"}
              />
            );
          })}
      </TeaserCluster>
      {!isLastElement && <hr className={styles.separator} />}
    </div>
  );
};

export { LatestNewsArticleCluster };
